import { LoadingService } from '@core/services/loading.service';
import { AlertService } from '@core/services/alert.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isNil } from 'lodash';
import { HEADER_EXTEND_KEYS } from '@core/constants/header-extend.constant';

@Injectable()
export class ErrorPopupInterceptor implements HttpInterceptor {
    constructor(private alertService: AlertService, private loadingService: LoadingService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
        const notShowDefaultAlertError: boolean = !isNil(
            request.headers.get(HEADER_EXTEND_KEYS.NOT_SHOW_DEFAULT_ALERT_ERROR)
        );

        if (notShowDefaultAlertError) {
            request = request.clone({
                headers: request.headers.delete(HEADER_EXTEND_KEYS.NOT_SHOW_DEFAULT_ALERT_ERROR)
            });
        }

        return next.handle(request).pipe(
            catchError((error) => {
                this.loadingService.hide();
                !notShowDefaultAlertError && this.alertService.showError(error, request);

                return throwError(error);
            })
        );
    }
}
